import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=60759f76&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"
import style0 from "./Tab.vue?vue&type=style&index=0&id=60759f76&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60759f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60759f76')) {
      api.createRecord('60759f76', component.options)
    } else {
      api.reload('60759f76', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=60759f76&scoped=true", function () {
      api.rerender('60759f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Tab.vue"
export default component.exports